import React from 'react';
import { Link } from 'react-router-dom';

import { checkPermission } from '../../../common/guards/can';
import { check } from '../../../../utils/tokenUtils';

const Information = (props) => {
  const { handleMenu } = props;
  return (
    <div className="nav-menu-links-list nav-menu-information">
      <h4>INFORMATION</h4>
      <div className="header-underline" />
      <Link to={'/about-ignite'} onClick={() => handleMenu()}>About Ignite</Link>
      {checkPermission('view', 'web_app_products_page') && check() && (
        <Link to={'/brands'} onClick={() => handleMenu()}>Our Brands</Link>
      )}
      {checkPermission('view', 'por_page') && check() && (
        <Link to={'/por-page'} onClick={() => handleMenu()}>POR Deals</Link>
      )}
      {check() ? (
        <Link to={'/contact-us'} onClick={() => handleMenu()}>Contact Us</Link>
      ) : (
        <Link to={'/contact'} onClick={() => handleMenu()}>Contact Us</Link>
      )}
    </div>
  );
};

export default Information;



// WEBPACK FOOTER //
// ./src/components/layout/user-navigation/navbar-items/information.jsx